import { CommonModule, NgOptimizedImage } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// NGPrime
import { AccordionModule } from 'primeng/accordion';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { BadgeModule } from 'primeng/badge';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CarouselModule } from 'primeng/carousel';
import { CascadeSelectModule } from 'primeng/cascadeselect';
import { ChartModule } from 'primeng/chart';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipModule } from 'primeng/chip';
import { ChipsModule } from 'primeng/chips';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ContextMenuModule } from 'primeng/contextmenu';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { DropdownModule } from 'primeng/dropdown';
import { FileUploadModule } from 'primeng/fileupload';
import { InputMaskModule } from 'primeng/inputmask';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { MenuModule } from 'primeng/menu';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { PaginatorModule } from 'primeng/paginator';
import { PanelMenuModule } from 'primeng/panelmenu';
import { ProgressBarModule } from 'primeng/progressbar';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { SidebarModule } from 'primeng/sidebar';
import { SlideMenuModule } from 'primeng/slidemenu';
import { SplitButtonModule } from 'primeng/splitbutton';
import { SplitterModule } from 'primeng/splitter';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { TagModule } from 'primeng/tag';
import { ToastModule } from 'primeng/toast';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { TooltipModule } from 'primeng/tooltip';
import { TreeModule } from 'primeng/tree';
import { TreeTableModule } from 'primeng/treetable';

// pipes
import { NgPipesModule } from 'ngx-pipes';

import { DragDropModule } from '@angular/cdk/drag-drop';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { NgSelectModule } from '@ng-select/ng-select';
import { ColorPickerModule } from 'ngx-color-picker'; // ? Ye wala install krna he he after hard install
import { NgxPermissionsModule } from 'ngx-permissions';

import { ToastrModule } from 'ngx-toastr';

import { NgScrollbarModule } from 'ngx-scrollbar';

import { FullCalendarModule } from '@fullcalendar/angular';
import { NgxCaptureModule } from 'ngx-capture';
import { NgxImageCaptureModule } from 'ngx-image-compress';
import { ImageCropperModule } from 'ngx-image-cropper';
import { KnobModule } from 'primeng/knob';
import { ListboxModule } from 'primeng/listbox';
import { OrderListModule } from 'primeng/orderlist';
import { SliderModule } from 'primeng/slider';
import { TabMenuModule } from 'primeng/tabmenu';
import { AmTimeAgoModule } from '@pipes/time-ago/am-time-ago.module';

const CommonModulesList: any[] = [
  ContextMenuModule,
  CommonModule,
  NgOptimizedImage,
  HttpClientModule,
  FormsModule,
  ReactiveFormsModule,
  NgPipesModule,
  ToastrModule.forRoot(),
  CalendarModule,
  CheckboxModule,
  CascadeSelectModule,
  DividerModule,
  AutoCompleteModule,
  ButtonModule,
  SplitterModule,
  BadgeModule,
  DropdownModule,
  MenuModule,
  ScrollPanelModule,
  AvatarModule,
  AvatarGroupModule,
  SplitButtonModule,
  AccordionModule,
  TableModule,
  InputMaskModule,
  PaginatorModule,
  RadioButtonModule,
  AvatarModule,
  AvatarGroupModule,
  TagModule,
  ConfirmPopupModule,
  DialogModule,
  TreeModule,
  InputTextareaModule,
  ToggleButtonModule,
  PanelMenuModule,
  SlideMenuModule,
  ProgressBarModule,
  ProgressSpinnerModule,
  TooltipModule,
  OrderListModule,
  KnobModule,
  TreeTableModule,
  DialogModule,
  TabViewModule,
  ChipModule,
  ChipsModule,
  NgSelectModule,
  NgxPermissionsModule.forChild(),
  ColorPickerModule,
  DragDropModule,
  CKEditorModule,
  InputSwitchModule,
  NgScrollbarModule,
  FileUploadModule,
  ToastModule,
  FullCalendarModule,
  CarouselModule,
  SidebarModule,
  OverlayPanelModule,
  ChartModule,
  ConfirmDialogModule,
  NgxCaptureModule,
  NgxImageCaptureModule,
  ImageCropperModule,
  SliderModule,
  ListboxModule,
  TabMenuModule,
  AmTimeAgoModule,
];

@NgModule({
  declarations: [],
  imports: [...CommonModulesList],
  exports: [...CommonModulesList],
  providers: [MessageService, ConfirmationService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class FirmwareCommonModule {}
